import { takeLatest, put, call, select } from 'redux-saga/effects';
import { apiRequest } from '../../apiRequest';
import { URLs } from '../../urls';
import {
	PostLoginActionsTypes,
	ILoginResult,
	PostLoginRequestSucces,
	PostLoginRequestError,
	DefaultRegisterActionsTypes,
	IDefaultRegisterResult,
	DefaultRegisterRequestSucces,
	DefaultRegisterRequestError
} from './types';

function* sendPostLoginRequest(action: any) {
	try {
		// API call
		const response : ILoginResult = yield call(apiRequest, {
			endpoint: URLs.POST_LOGIN_ENDPOINT,
			method: 'POST',
			body: action.model
		});

		if (response.success == true) {
			let putData: PostLoginRequestSucces = {
				type: PostLoginActionsTypes.POST_LOGIN_SUCCESS,
				data: response,
				loading: false,
			};
			localStorage.accessToken = response.data.token;
      		localStorage.refreshToken = response.data.refreshToken;

			yield put<PostLoginRequestSucces>(putData);
		}

		if (response.success == false) {
			let putData: PostLoginRequestError = {
				type: PostLoginActionsTypes.POST_LOGIN_ERROR,
				error: response.error.toString(),
				loading: false
			};

			yield put<PostLoginRequestError>(putData);
		}

	} catch (e: any) {
		let putData: PostLoginRequestError = {
			type: PostLoginActionsTypes.POST_LOGIN_ERROR,
			error: e,
			loading: false
		};
		yield put<PostLoginRequestError>(putData);
	}
}

// Helper to generate UUID for fallback userId
function generateUUID(): string {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		const r = Math.random() * 16 | 0;
		const v = c === 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}

function* checkLoggedIn(action: any) {
	let userId = localStorage.getItem("UserId");
	
	// If userId already exists in localStorage - just dispatch success
	if (userId && userId !== 'null') {
		let putData: DefaultRegisterRequestSucces = {
			type: DefaultRegisterActionsTypes.DEFAULT_REGISTER_SUCCESS,
			data: { data: userId, success: true, error: 0 },
			loading: false,
		};
		yield put<DefaultRegisterRequestSucces>(putData);
		return;
	}
	
	// No userId - try to get from API
	try {
		const response : IDefaultRegisterResult = yield call(apiRequest, {
			endpoint: URLs.GET_DEFAULT_REGISTER_ENDPOINT,
			method: 'GET',
		});
		
		if (response.success == true) {
			let putData: DefaultRegisterRequestSucces = {
				type: DefaultRegisterActionsTypes.DEFAULT_REGISTER_SUCCESS,
				data: response,
				loading: false,
			};
			localStorage.UserId = response.data;
			localStorage.setItem("UserId", response.data);
			yield put<DefaultRegisterRequestSucces>(putData);
		}

		if (response.success == false) {
			// API returned error - generate UUID as fallback
			const fallbackUserId = generateUUID();
			localStorage.setItem("UserId", fallbackUserId);
			
			let putData: DefaultRegisterRequestSucces = {
				type: DefaultRegisterActionsTypes.DEFAULT_REGISTER_SUCCESS,
				data: { data: fallbackUserId, success: true, error: 0 },
				loading: false,
			};
			yield put<DefaultRegisterRequestSucces>(putData);
		}

	} catch (e: any) {
		// API call failed - generate UUID as fallback
		const fallbackUserId = generateUUID();
		localStorage.setItem("UserId", fallbackUserId);
		
		let putData: DefaultRegisterRequestSucces = {
			type: DefaultRegisterActionsTypes.DEFAULT_REGISTER_SUCCESS,
			data: { data: fallbackUserId, success: true, error: 0 },
			loading: false,
		};
		yield put<DefaultRegisterRequestSucces>(putData);
	}
}


export function* handler() {
	yield takeLatest(PostLoginActionsTypes.POST_LOGIN, sendPostLoginRequest);
	yield takeLatest(DefaultRegisterActionsTypes.DEFAULT_REGISTER, checkLoggedIn);
}

